import React from 'react'
import CleverLogin from './CleverLogin';
import { IRememberMeKlassDetail } from './interfacesAndConstants';
import { APIS } from '../api';
import { sendErrorToSentry } from '../../teacherDashboard/teacher/components/teacher_app_container/ErrorBoundary/sendErrorToSentry';
import { CommonMessages } from '../../teacherDashboard/utils/constants';
import ClassCodeIcon from './../assets/class-code.svg';
import QRCodeIcon from './../assets/qr-code.svg';
import { useSuiTurnstileState } from 'schoolUiComponents/SuiTurnstile';


const LastUsedClass = ({ rememberMeKlassDetails, sendInteractedEvent }: { rememberMeKlassDetails: IRememberMeKlassDetail[]; sendInteractedEvent: (label: string) => void }) => {
  const { token } = useSuiTurnstileState();
  const LOGIN_TYPE = [
    {
      label: "Class code",
      path: "#student-klasscode?fromPage=Login method selection screen",
      svgImage: <ClassCodeIcon alt={"Class code"} />
    },
    {
      label: "QR code",
      path: "#student-qrcode?fromPage=Login method selection screen",
      svgImage: <QRCodeIcon alt={"QR code"} />
    }
  ]

  const klassOnclickHandler = (klass: IRememberMeKlassDetail) => {
    sendInteractedEvent("Continue using last class")
    trackEventsForGuests("Class Login Attempted", { "mp_login_user_type": "student", "Login Method": "Saved class" }, { send_mixpanel: true })
    APIS.klassCodeLogin(klass?.klass_code, true, token)
      .then((res) => {
        window.location.href = "/klass/student_roster?loginMethod=Saved class&fromPage=Saved class screen";
      })
      .catch((error) => {
        if(token && (error?.response?.status !== 406)) {
          if (error?.response?.data) {
            showFlashMessage(error?.response?.data?.debug_message || error?.response?.data?.message, 'error');
          } else {
            showFlashMessage(CommonMessages.commonErrorMessage, 'error');
          }
        }
        if (error?.response?.data?.reload) {
          window.location.reload();
        }
        if(error?.response?.status !== 404){
          sendErrorToSentry(new Error("Error in klassOnclickHandler inside LastUsedClass " + (error?.response?.data?.message || error?.response?.data?.debug_message || "")), { error: error });
        }
      });
  }



  return (
    <div className='last-used-class'>
      <h4>Continue with last used class</h4>
      <div className="classes-list">
        {
          rememberMeKlassDetails.map((klass: IRememberMeKlassDetail) => (
            <div className="student-card-l1">
              <div className="student-card-l2">
                <div className="student-card" onClick={() => klassOnclickHandler(klass)}>
                  <label>{klass?.klass_name?.replace(/\+/g, " ")} </label>
                  <div className="arrow-icon">
                    <i className="iconcust-iconBackBtn"></i>
                  </div>
                </div>
              </div>
            </div>
          ))
        }
      </div>
      <div className="or-sec">
        <p className="or-sec-text">OR</p>
      </div>
      <h5>Login to another class</h5>
      <div className="login-btns">
        {
          LOGIN_TYPE?.map((type) => (
            <a href={type.path} className="login-btn-type" onClick={() => sendInteractedEvent(type.label)}>
              {type.svgImage}
              {type.label}
            </a>
          ))
        }
        <CleverLogin />
      </div>
    </div >
  )
}

export default LastUsedClass